import Loader from "../Loader/Loader";
import "../Loader/Loader.scss";

const FullScreenLoader = () => {
  return (
    <div className={"full-screen-loader"}>
      <Loader />
    </div>
  );
};

export default FullScreenLoader;
